import api from 'state/axios';

export const logClientAction = async (action, payload = {}) => {
    try {
        await api.post('/userlogs/logclientaction', { action, payload });
    } catch (e) {
        console.error("Client log error", e);
    }
};
